import type { ComponentType } from 'react';

import type { TFunction } from 'i18next';
import type { LucideProps } from 'lucide-react';
import { Layers, Waves } from 'lucide-react';

import type { SarAoiAnalysisKind } from '@/mocks/floodJobs';

export interface AnalysisKindMeta {
  kind: SarAoiAnalysisKind;
  /** Icon component (lucide-react) cho label / tag. */
  Icon: ComponentType<LucideProps>;
  /** Accent color (hex) dùng cho icon / border / tag. */
  accentColor: string;
  /** i18n key cho nhãn ngắn (wizard Segmented, pipeline tag). */
  labelKey: string;
  /** i18n key cho tiêu đề dài (modal title). */
  longLabelKey: string;
  /** i18n key cho tiêu đề overlay tiến độ. */
  progressTitleKey: string;
  /** Ant tag color name (cho `<Tag color="...">`). */
  antTagColor: 'blue' | 'lime';
  /** Source vệ tinh dùng để hiển thị ở các chú thích kỹ thuật. */
  satelliteSource: 'Sentinel-1' | 'Sentinel-2';
}

const META: Record<SarAoiAnalysisKind, AnalysisKindMeta> = {
  sarFlood: {
    kind: 'sarFlood',
    Icon: Waves,
    accentColor: '#38bdf8',
    labelKey: 'map.sarAoi.analysisKindFlood',
    longLabelKey: 'ops.jobs.sarResult.title',
    progressTitleKey: 'ops.jobs.mapProgress.title',
    antTagColor: 'blue',
    satelliteSource: 'Sentinel-1',
  },
  landCover: {
    kind: 'landCover',
    Icon: Layers,
    accentColor: '#a3e635',
    labelKey: 'map.sarAoi.analysisKindLandCover',
    longLabelKey: 'ops.jobs.sarResult.titleLandCover',
    progressTitleKey: 'ops.jobs.mapProgress.titleLandCover',
    antTagColor: 'lime',
    satelliteSource: 'Sentinel-2',
  },
};

export function getAnalysisKindMeta(kind: SarAoiAnalysisKind | undefined | null): AnalysisKindMeta {
  return kind === 'landCover' ? META.landCover : META.sarFlood;
}

export function analysisKindShortLabel(
  t: TFunction,
  kind: SarAoiAnalysisKind | undefined | null,
): string {
  return t(getAnalysisKindMeta(kind).labelKey);
}
